import ENUM from "@/enum/parameters";
import {getWidgetParameterConfig} from "@/helpers/widgetUtils";

export default {
    computed: {
        autoCompletes () {
            return this.model.WidgetConfig.filter(config => this.isAutoComplete(config))
        },
        filtersConfig () {
           return [
                ...ENUM.AUTO_COMPLETE_TYPE_KEYS,
                ...ENUM.MULTISELECT_TYPE_KEYS
            ]
        },
        widgetConfig() {
            if (!this.model.WidgetConfig || !this.model.WidgetConfig.length) {
                return {
                    filters: [],
                    otherFilters: []
                }
            }
            return this.model.WidgetConfig.reduce((acc, filter) => {
                if (this.isOtherFilters(filter) && filter.ParameterType) {
                    acc.otherFilters.push(filter)
                } else if (!this.isOtherFilters(filter)) {
                    acc.filters.push(filter)
                }
                return acc
            }, {
                filters: [],
                otherFilters: []
            })
        }
    },
    methods: {
        isAutoComplete(config) {
            return ENUM.AUTO_COMPLETE_TYPE_KEYS.includes(config.ParameterType)
        },
        getWidgetConfig (config) {
            const templateId = this.model.TemplateID
            const template = this.$store.getters['templatesCategory/getWidgetTemplate'](templateId)

            return {
                ...getWidgetParameterConfig(template, config.ParameterID, [ 'EntityTypeID', 'ParameterData' ]),
                ...config
            }
        },
        isMultiSelect(config) {
            return ENUM.MULTISELECT_TYPE_KEYS.includes(config.ParameterType)
        },
        isOtherFilters(config) {
            return !this.filtersConfig.includes(config.ParameterType)
        },
        updateWidgetConfig (model, filterObject) {
            if (filterObject) {
                filterObject.WidgetParameterValue = model.WidgetParameterValue
                filterObject.WidgetParameterValueJson = model.WidgetParameterValueJson
            }
        }
    }
}
